import { persistStore } from "./persistStore";
import { writable } from "svelte/store";
export var store = persistStore("data", []);
export var gameState = writable({
    currentGame: null
});
var defaultSettings = {
    theme: "light",
    language: "de"
};
export var settings = persistStore("settings", defaultSettings);
